import {createFileRoute, SearchSchemaInput} from '@tanstack/react-router';

import SessionPaymentReturnPage from '../../pages/SessionPaymentReturnPage.tsx';

export const Route = createFileRoute('/return/session-payment')({
    validateSearch: (search: Record<string, unknown> & SearchSchemaInput) => ({
        state: typeof search.state === 'string' ? search.state : 'unknown',
    }),
    component: RouteComponent,
});

function RouteComponent() {
    const {state} = Route.useSearch();

    return <SessionPaymentReturnPage state={state}/>;
}
